<template>
  <div class="home">
    <swiper class="topBanner" ref="bannerSwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in list_img" :key="index">
        <img
          class="top_banner"
          :src="item.url"
          style="overflow:hidden; object-fit: cover;"
          alt
      /></swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="info">
      <h3 class="title01">成立背景</h3>
      <div style="margin-bottom: 4.5rem;">
        <span>
          <font style="font-weight: 600;">永新科技（YONGXIN）</font
          >，我们是您在信息技术<br />
          和广告服务领域的创新合作伙伴。<br />
          我们成立于 2023年初，总部位于中国香港,<br />
          专注于提供尖端IT解决方案和广告智能营销。<br />
          我们的专家团队致力于提供满足每个客户独特需求的定制解决方案，<br />
          从开发强大的网站和应用程序到执行全面的数字营销活动，<br />
          满足企业的数字化、智能化需求，<br />
          帮助客户创造、提升价值，与客户共同成长。<br />
          我们的核心服务包括但不限于：<br />
          <font style="font-weight: 600;">IT 支持和咨询：</font><br />
          提供可靠的IT支持和战略咨询，帮助企业应对技术挑战。<br />
          <font style="font-weight: 600;">移动应用开发：</font><br />
          设计和开发吸引用户并简化运营的创新移动应用程序。<br />
          <font style="font-weight: 600;">数字营销：</font><br />
          实施有效的策略，包括SEO、PPC、社交媒体<br />
          营销和内容创建，以提高您的在线知名度。<br />
        </span>
      </div>

      <div>
        <swiper
          class="centerSwiper"
          ref="centerSwiper"
          :options="swiperOptions"
        >
          <swiper-slide v-for="(item, index) in firstAlbum" :key="index">
            <div style="text-align: center;margin-bottom: 7.9375rem;">
              <img
                :src="item.url"
                alt
                style="width:29.375rem;height:29.375rem; margin-bottom: 3.125rem;"
              />
              <span
                style="color:#1A1A1A;font-size: 1.5rem;line-height: 1.75rem;font-weight: 500; display: block;margin-bottom: 1.8125rem;"
                >{{ item.title }}</span
              >
              <div
                v-html="item.desc"
                style="color:#777777;font-size: 1.5rem;line-height: 2.25rem;"
              ></div>
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
            style="margin-bottom:4.375rem"
          ></div>
        </swiper>
      </div>
    </div>

    <div
      style="background-color:#E6F0FB;padding-top: 3.625rem; padding-bottom: 4.375rem;text-align: center;"
    >
      <h3>团队力量</h3>
      <img
        :src="require('../../assets/power.png')"
        alt
        style="vertical-align: middle;width:37.5rem;height:23.9375rem;margin-top:3.625rem ;margin-bottom: 4.375rem;margin-right:4.6875rem; margin-left: 4.6875rem;"
      />
      <span>
        公司团队由一批业界资深的专业人士组成，<br />
        大部分成员曾就职于各大领尖互联网公司。<br />
        我们的目标专注深耕全球市场，战略伙伴网络遍布全球，<br />
        拥有上亿用户流量，利用强大的资源整合能力为客户实现共赢。
      </span>
    </div>

    <div>
      <h3 class="title03">企业愿景</h3>
      <span>我们的使命是弥合技术与创意之间的差距，为客户创造更高价值</span>
      <div style="margin-top:4.375rem; margin-bottom:4.375rem">
        <swiper class="bottomSwiper" :options="swiperOption">
          <swiper-slide
            class="slide"
            v-for="(item, index) in secondAlbum"
            :key="index"
          >
            <img
              class="bottom_banner"
              :src="item.url"
              style="overflow:hidden; object-fit: cover;"
              alt
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "公司简介",
      list_img: [
        { url: require("../../assets/banner.png") },
        { url: require("../../assets/banner.png") }
      ],
      firstAlbum: [
        {
          url: require("../../assets/album01/album01_0.png"),
          title: "开放进取",
          desc: "主动担当，积极主动<br/>拥抱变化，善于创新"
        },
        {
          url: require("../../assets/album01/album01_1.png"),
          title: "诚信为先",
          desc:
            "用户至上，以产品为核心<br/>专业的团队做专业的事，<br/>打造富有生命力的海外产品矩阵"
        },
        {
          url: require("../../assets/album01/album01_2.png"),
          title: "合作共赢",
          desc:
            "以优质的产品与用户共创价值，<br/>以实现员工与合作伙伴的<br/>理想为己任"
        },
        {
          url: require("../../assets/album01/album01_3.png"),
          title: "追求卓越",
          desc: "孵化梦想，成就专业<br/>深度思考，快速执行"
        }
      ],
      secondAlbum: [
        { url: require("../../assets/album02/album02_0.png") },
        { url: require("../../assets/album02/album02_1.png") },
        { url: require("../../assets/album02/album02_2.png") }
      ],
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination"
        }
      },
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home {
  text-align: center;
  padding: 0;
  margin: 0;
}
.info {
  width: 100%;
  text-align: center;
  align-items: center;
  padding: 0;
  margin: 0;
}
.title01 {
  margin-top: 3.625rem;
  margin-bottom: 2.1875rem;
}

.title03 {
  margin-top: 3.625rem;
  margin-bottom: 2.1875rem;
}

h3 {
  color: #1a1a1a;
  font-size: 2.25rem;
  line-height: 3.75rem;
}
span {
  color: #777;
  font-size: 1.5rem;
  line-height: 2.25rem;
}
.top_banner {
  width: 100%;
  height: 26.75rem;
  margin: 0;
  object-fit: cover;
  overflow: hidden;
}
.centerSwiper.swiper-container {
  --swiper-pagination-color: #0090e3;
}
.centerSwiper.swiper-container {
  --swiper-pagination-color: #0090e3;
}

.swiper-pagination /deep/ .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: red;
  opacity: 0.2;
}
.swiper-pagination /deep/ .swiper-pagination-bullet {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  border-radius: 100%;
  background: rgba(0, 144, 227);
  opacity: 0.1;
}
.swiper-pagination /deep/ .swiper-pagination-bullet-active {
  width: 0.5rem;
  height: 0.5rem;
  display: inline-block;
  border-radius: 100%;
  background: rgba(0, 144, 227);
  opacity: 1;
}
/* background-color: */
.bottom_banner {
  width: 100%;
  height: 21.25rem;
  margin: 0;
  object-fit: cover;
  overflow: hidden;
}
@import "./base.scss";

.bottomSwiper .swiper-container {
  width: 100%;
  height: 100%;
}
.bottomSwiper .swiper-container img {
  width: 100%;
  height: 100%;
}
.bottomSwiper .swiper-slide {
  width: 75%;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.95);
}
.bottomSwiper .swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/HomePage.vue